import _regeneratorRuntime from "babel-runtime/regenerator";
import { autorun } from "mobx";
import { types, getParentOfType, getEnv, flow } from "mobx-state-tree";
import { get } from "lodash-es";
import { generateId } from "../core/utils";
import { Store } from "./Store";

export var DataSourceProviderModel = types.model("DataSourceModel", {
  id: types.optional(types.identifier, function () {
    return generateId();
  })
}).volatile(function () {
  return {
    authData: null,
    user: null
  };
}).views(function (self) {
  return {
    get authProvider() {
      return getEnv(self).authProvider;
    }
  };
}).actions(function (self) {
  var uriDisposer = void 0;

  return {
    setAuthData: function setAuthData(authData) {
      self.authData = authData;
    },
    setUser: function setUser(user) {
      self.user = user;
    },
    signIn: function signIn() {
      return self.authProvider.login();
    },
    signOut: function signOut() {
      return self.authProvider.logout();
    },

    fetchData: flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref, authData, user;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return self.authProvider.checkAuth();

            case 3:
              _ref = _context.sent;
              authData = _ref.authData;
              user = _ref.user;

              self.setAuthData(authData);
              self.setUser(user);
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);

              self.user = null;
              self.authData = null;

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 10]]);
    })),
    afterCreate: function afterCreate() {
      uriDisposer = autorun(function () {
        self.fetchData();
      });
    },
    beforeDestroy: function beforeDestroy() {
      if (uriDisposer) {
        uriDisposer();
      }
    }
  };
});

export var DataSourceModel = types.model("DataSourceModel", {
  id: types.optional(types.identifier, function () {
    return generateId();
  }),
  url: types.frozen(null),
  token: types.frozen(null),
  accessData: types.frozen(null),
  data: types.frozen(null),
  pivot: 0
}).views(function (self) {
  return {
    get store() {
      return getParentOfType(self, Store);
    },
    get fields() {
      if (!self.data) {
        return [];
      }

      return self.data.values.map(function (v) {
        return {
          label: "" + v[0],
          value: v[self.pivot + 1]
        };
      });
    }
  };
}).actions(function (self) {
  var accessDataDisposer = void 0;

  return {
    decrementPivot: function decrementPivot() {
      if (self.pivot === 0) {
        return;
      }

      self.pivot = self.pivot - 1;
    },
    incrementPivot: function incrementPivot() {
      if (self.pivot === self.fields.length - 1) {
        return;
      }

      self.pivot = self.pivot + 1;
    },
    setUrl: function setUrl(url) {
      self.url = url;
    },
    setData: function setData(data) {
      self.data = data;
    },
    setAccessData: function setAccessData(accessData) {
      self.accessData = accessData;
    },

    fetchData: flow( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(accessData) {
      var dataSourceProvider, _self$accessData, spreadId, sheetName, range, fullRange, request, data;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dataSourceProvider = self.store.dataSourceProvider;

              if (!(!accessData || !get(dataSourceProvider, "authData"))) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              _self$accessData = self.accessData, spreadId = _self$accessData.spreadId, sheetName = _self$accessData.sheetName, range = _self$accessData.range;
              fullRange = sheetName + "!" + range;
              _context2.next = 7;
              return fetch("https://sheets.googleapis.com/v4/spreadsheets/" + spreadId + "/values/" + fullRange + "?valueRenderOption=UNFORMATTED_VALUE&majorDimension=COLUMNS", {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + dataSourceProvider.authData.access_token
                }
              });

            case 7:
              request = _context2.sent;
              _context2.next = 10;
              return request.json();

            case 10:
              data = _context2.sent;

              self.setData(data);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    })),
    afterCreate: function afterCreate() {
      accessDataDisposer = autorun(function () {
        self.fetchData(self.accessData);
      });
    },
    beforeDestroy: function beforeDestroy() {
      if (accessDataDisposer) {
        accessDataDisposer();
      }
    }
  };
});